export default __webpack_public_path__ + "static/media/SFTSchriftedSansTRIAL-DemiBold-BF6413e1ee404fe.0405895d.otf";